<template>
  <div>
    <div
      class="modal fade"
      :ref="`modal-select-multiplate-asset`"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              {{ $t(modalTitle) }}
            </h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12" v-if="notiData !== ''">
                <div class="form-group">
                  {{ $t(notiData) }}
                </div>
              </div>
              <div
                class="col-md-12"
                v-if="
                  isShowMaintenanceType ||
                    isShowTitle ||
                    isShowPrice ||
                    isShowDescription
                "
              >
                <div class="form-group" v-if="isShowMaintenanceType">
                  <label for="">{{
                    $t("propertyMaintenance.typeOfMaintenance")
                  }}</label>
                  <v-select
                    class="clear"
                    :options="maintenanceTypeList"
                    :getOptionLabel="option => option.default"
                    :reduce="data => data.id"
                    label="text"
                    :placeholder="$t('propertyMaintenance.typeOfMaintenance')"
                    :clearable="false"
                    v-model="maintenanceTypeValue"
                    :disabled="disableMaintenanceType"
                  >
                    <template v-slot:option="option">
                      {{ $t(option.default) }}
                    </template>
                  </v-select>
                </div>
                <div class="form-group" v-if="isShowTitle">
                  <label for="">{{
                    $t("propertyMaintenance.maintenanceTitle")
                  }}</label>
                  <input type="text" class="form-control" v-model="titleData" />
                </div>
                <div class="form-group" v-if="isShowPrice">
                  <label for="">{{ $t("propertyMaintenance.price") }}</label>
                  <input
                    type="number"
                    class="form-control"
                    v-model="priceData"
                  />
                </div>
                <div class="form-group" v-if="isShowDescription">
                  <label for="">{{
                    $t("propertyMaintenance.description")
                  }}</label>
                  <textarea
                    name=""
                    id=""
                    cols="30"
                    rows="3"
                    class="form-control"
                    v-model="description"
                  ></textarea>
                </div>
                <hr />
              </div>
              <div class="col-md-12" v-show="isAssetTable">
                <div class="row" style="margin-top: 10px">
                  <div class="col-md-6">
                    <div class="form-group">
                      <input
                        type="text"
                        class="form-control"
                        :placeholder="$t('common.search')"
                        v-model="assetSearch.searchText"
                        @keyup.enter="onSearch"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <button
                      type="button"
                      class="btn btn-primary"
                      @click="onSearch"
                    >
                      {{ $t("common.search") }}
                    </button>
                  </div>
                </div>
                <div>
                  <b-table
                    :items="items"
                    :fields="fields"
                    :select-mode="`multi`"
                    responsive="sm"
                    ref="selectableTable"
                    selectable
                    @row-selected="onRowSelected"
                  >
                    <!-- header -->
                    <template #head()="row">
                      {{ $t(row.label) }}
                    </template>
                    <template #head(selected)>
                      <input
                        type="checkbox"
                        id="checkbox"
                        v-model="selectAllCheckBox"
                        @change="onChangeSelectAllCheckBox(selectAllCheckBox)"
                      />
                    </template>
                    <!-- Example scoped slot for select state illustrative purposes -->
                    <template #cell(selected)="row">
                      <input
                        type="checkbox"
                        id="checkbox"
                        v-model="row.item.isSelect"
                        @change="onSelectCheckbox(row.item.isSelect, row.index)"
                      />
                    </template>
                  </b-table>
                </div>
                <div class="box-footer clearfix" style="display:contents;">
                  <paginator
                    :totalItem="paginateData.totalItem"
                    :currentPage="paginateData.currentPage"
                    :pageSize="paginateData.pageSize"
                    :totalPage="paginateData.totalPage"
                    @onpaginate="onPagination"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer" style="text-align: center">
            <button
              style="background-color: #f29911;border-color: #f29911;color:#fff"
              type="button"
              class="btn btn-default pull-left"
              @click="onCloseModal"
            >
              {{ $t("common.back") }}
            </button>
            <button
              type="button"
              class="btn btn-primary pull-right"
              @click="onSave"
            >
              {{ $t("common.confirm") }}
            </button>
          </div>
        </div>
      </div>
      <lte-core-alert
        v-for="snackbar in GET_SNACK_BAR"
        :key="snackbar.id"
        :item="snackbar"
      ></lte-core-alert>
    </div>
  </div>
</template>
<script>
import Paginator from "@/components/CustomPaginator.vue";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import { mapActions, mapGetters } from "vuex";
import Enum from "../../../enum/enum";
import utils from "@/lib/utils";

export default {
  components: {
    paginator: Paginator,
    "lte-core-alert": LTECoreAlert
  },
  props: {
    modalTitle: {
      type: String,
      default: () => {
        return "";
      }
    },
    notiData: {
      type: String,
      default: () => {
        return "";
      }
    },
    // prop show ui
    isShowMaintenanceType: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    isShowTitle: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    isShowDescription: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    isAssetTable: {
      type: Boolean,
      default: () => {
        return true;
      }
    },
    isShowPrice: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    // prop filter
    excludeAssetActivityTracking: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    filterAssetActivityTracking: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    filterAssetActivityPlan: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    activityPlanMaintenanceTypeId: {
      type: Number,
      default: () => {
        return null;
      }
    },
    activityPlanStatus: {
      type: Number,
      default: () => {
        return null;
      }
    }
  },
  data: () => ({
    items: [],
    fields: [
      { key: "selected" },
      {
        key: "nonumber",
        label: "common.nonumber"
      },
      {
        key: "assetCode",
        label: "common.code"
      },
      {
        key: "assetName",
        label: "property.asset.name"
      },
      {
        key: "assetLocation",
        label: "property.asset.location"
      },
      {
        key: "assetSeriCode",
        label: "property.asset.seriCode"
      },
      {
        key: "assetModel",
        label: "property.asset.model"
      }
    ],
    selectAllCheckBox: false,
    assetSearch: {
      searchText: null
    },
    paginateData: {
      totalItem: 1,
      currentPage: 1,
      pageSize: 1,
      totalPage: 1
    },
    maintenanceTypeList: [],
    maintenanceTypeValue: 1,
    disableMaintenanceType: false,
    titleData: null,
    description: null,
    feedbackId: null,
    priceData: null,
    selected: []
  }),
  watch: {
    GET_ASSET_LIST_DATA_V2: function() {
      let paginate = this.GET_ASSET_LIST_DATA_V2.paginate;
      this.paginateData = {
        totalItem: paginate.totalItem,
        currentPage: paginate.currentPage,
        pageSize: paginate.pageSize,
        totalPage: paginate.numPages
      };
      this.items = [];
      let data = this.GET_ASSET_LIST_DATA_V2.results;
      data.forEach((e, i) => {
        let nonumber = i + 1 + (paginate.currentPage - 1) * paginate.pageSize;
        let item = {
          nonumber: nonumber,
          id: e.id,
          assetCode: e.code,
          assetName: e.name,
          assetLocation: e.location,
          assetModel: e.asset_model,
          assetSeriCode: e.seri_code,
          isSelect: false
        };
        this.items.push(item);
      });
    },
    GET_MAINTENANCE_TYPE_LIST_DATA: function() {
      let data = this.GET_MAINTENANCE_TYPE_LIST_DATA;
      this.maintenanceTypeList = data;
    }
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "GET_ASSET_LIST_DATA_V2",
      "GET_MAINTENANCE_TYPE_LIST_DATA"
    ])
  },
  methods: {
    onCloseModal: function() {
      $(this.$refs[`modal-select-multiplate-asset`]).modal("hide");
    },
    onShowModal: function() {
      $(this.$refs[`modal-select-multiplate-asset`]).modal("show");
    },
    showError: function(msg) {
      this.ON_SHOW_TOAST({
        message: this.$t(msg),
        styleType: "danger"
      });
    },
    onPagination: function(data) {
      this.getAssetList(data);
    },
    onSearch: function() {
      this.getAssetList(1);
    },
    validateData: function() {
      let validateResult = "OK";
      if (this.isShowTitle && utils.isEmptyString(this.titleData)) {
        validateResult = "propertyMaintenance.maintenanceTitle";
      }
      return validateResult;
    },
    onSave: function() {
      let results = this.validateData();
      if (results === "OK") {
        let data = {};
        if (this.isAssetTable) {
          data["assetList"] = this.selected;
        }
        if (this.isShowMaintenanceType) {
          data["maintenanceType"] = this.maintenanceTypeValue;
        }
        if (this.isShowTitle) {
          data["title"] = this.titleData;
        }
        if (this.isShowDescription) {
          data["description"] = this.description;
        }
        if (this.isShowPrice) {
          data["price"] = utils.getCleanStringValue(this.priceData);
        }
        this.$emit("emitAssetSelect", data);
        // if (this.filterAssetActivityTracking) {
        //   if (this.maintenanceTypeList.length === 0) {
        //     this.showError("propertyMaintenance.typeOfMaintenance");
        //   } else {
        //     this.$emit("emitAssetSelect", {
        //       assetList: this.selected,
        //       maintenanceType: this.maintenanceTypeValue,
        //       description: this.description,
        //       title: this.titleData
        //     });
        //     this.onCloseModal();
        //   }
        // } else {
        //   this.$emit("emitAssetSelect", this.selected);
        //   this.onCloseModal();
        // }
      } else {
        this.showError(results);
      }
    },
    onSelectAsset: function(maintenanceTypeValue, feedbackId) {
      if (maintenanceTypeValue === Enum.MaintenanceTypeEnum.INCIDENT) {
        this.maintenanceTypeValue = maintenanceTypeValue;
        this.disableMaintenanceType = true;
        this.feedbackId = feedbackId;
      } else {
        this.maintenanceTypeValue = Enum.MaintenanceTypeEnum.MAINTENANCE;
        this.disableMaintenanceType = false;
        this.feedbackId = null;
      }
      this.selectAllCheckBox = false;
      this.items = [];
      this.getAssetList(1);
      this.onChangeSelectAllCheckBox(false);
      this.getMaintenanceTypeList();
      this.onShowModal();
      this.titleData = null;
      this.priceData = null;
      this.description = null;
    },
    onRowSelected: function(items) {
      items.isSelect = !items.isSelect;
      this.items.forEach(e => {
        let index = items.findIndex(x => x.id === e.id);
        if (index !== -1) {
          e.isSelect = true;
        } else {
          e.isSelect = false;
        }
      });
      this.selected = items;
      if (this.selected.length === this.items.length && items.length > 0) {
        this.selectAllCheckBox = true;
      } else {
        this.selectAllCheckBox = false;
      }
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows();
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected();
    },
    selectBtableRow(index) {
      this.$refs.selectableTable.selectRow(index);
    },
    unselectBtableRow(index) {
      this.$refs.selectableTable.unselectRow(index);
    },
    onSelectCheckbox: function(value, index) {
      if (value) {
        this.selectBtableRow(index);
      } else {
        this.unselectBtableRow(index);
      }
    },
    onChangeSelectAllCheckBox: function(value) {
      if (value) {
        this.selectAllRows();
      } else {
        this.clearSelected();
      }
    },
    getAssetList: function(page) {
      let filter = {
        params: {
          page: page,
          page_size: 10,
          searchText: this.assetSearch.searchText,
          excludeAssetActivityTracking: this.excludeAssetActivityTracking,
          filterAssetActivityTracking: this.filterAssetActivityTracking,
          filterAssetActivityPlan: this.filterAssetActivityPlan,
          activityPlanMaintenanceTypeId: this.activityPlanMaintenanceTypeId,
          activityPlanStatus: this.activityPlanStatus
        }
      };
      this.GET_ASSET_LIST_V2(filter);
    },
    getMaintenanceTypeList: function() {
      this.GET_MAINTENANCE_TYPE_LIST();
    },
    ...mapActions([
      "GET_ASSET_LIST_V2",
      "GET_MAINTENANCE_TYPE_LIST",
      "ON_SHOW_TOAST"
    ])
  }
};
</script>



// WEBPACK FOOTER //
// src/views/Property/SelectMultiplateAssetModal.vue